import { render } from "./SpecialOffer.vue?vue&type=template&id=3e3c4d9d"
import script from "./SpecialOffer.vue?vue&type=script&lang=js"
export * from "./SpecialOffer.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/dating-app/dating-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__